import React from 'react';
// import DropdownIcon from './images/dropdownIcon.svg';
import DropDownSelect from "./DropDown";


function SortByDropdown(props) {
    const sortBy = [
        {collection_name: 'Popularity', collection_id: 'popularity'},
        {collection_name: 'Price (L - H)', collection_id: 'price-l-h'},
        {collection_name: 'Price (H - L)', collection_id: 'price-h-l'},
        // {collection_name: 'Duration (L - H)', collection_id: 'duration-l-h'},
        // {collection_name: 'Duration (H - L)', collection_id: 'duration-h-l'},
        {collection_name: 'Rating (L - H)', collection_id: 'rating-l-h'},
        {collection_name: 'Rating (H - L)', collection_id: 'rating-h-l'}
    ]
    return (
        <DropDownSelect 
        showRightIcon={false}
        menuItem={sortBy} 
        selectedItem={ 'Sort by' }
        selectedItemId={ 'all' }
        itemSelected={ props.itemSelected }
        />
    );
}
export default SortByDropdown;


// WEBPACK FOOTER //
// ./src/SortByDropdown.jsx